const TOAST = {
  DIRECTIONS: {
    TOP: 'top',
    BOTTOM: 'bottom',
  },
  EVENTS: {
    SHOW_TOAST: 'showtoast',
    HIDE_ALL_TOASTS: 'hidetoasts',
  },
};

export default Object.freeze(TOAST);
